module.exports = __webpack_public_path__ + "img/ico15.f9617983.svg";